import { addDays } from "date-fns";
import { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch } from "react-redux";
import { setTimeSeries } from "../../../../redux/features/dashboardSlice";
// import { setTimeSeries } from "../../../redux/features/dashboardSlice";
import moment from "moment";
export default function DateRangePickerr(props) {
  const dispatch = useDispatch();
  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  useEffect(() => {
    dispatch(
      setTimeSeries({
        start: moment(state[0].startDate).format("DD-MM-YYYY"),
        end: moment(state[0].endDate).format("DD-MM-YYYY"),
      })
    );
  }, [state]);

  return (
    <DateRangePicker
      // onChange={(item, val) => {
      //   console.log({ item, val });

      //   setState([item.selection]);
      // }}
      onChange={(item, val) => {
        // console.log({ item });
        if (item.selection.endDate < new Date()) {
          setState([item.selection]);
        }
      }}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      maxDate={new Date()}
      months={2}
      ranges={state}
      direction="horizontal"
    />
  );
}
